export default __webpack_public_path__ + "static/media/RYS_2565.b48d7c74.jpg";